module.exports = __webpack_public_path__ + "img/369.c917b52a.jpg";